// extracted by mini-css-extract-plugin
module.exports = {"camStill":"CamStill_camStill__SflzF","videoIcon":"CamStill_videoIcon__ZWQ1f","playIconContainer":"CamStill_playIconContainer__qVbxT"};